const MUTABLE_CELL = Symbol('MUTABLE_CELL');

export { MUTABLE_CELL };
